/**
 * ProtectedRoute Component
 *
 * Wrapper component that ensures user is authenticated before rendering children
 */

import { useAuth } from "../../context/AuthContext";
import Login from "../Login/Login";
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <DashboardLayout>
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <MDTypography variant="h6" color="text">
            Loading...
          </MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }

  // Show login if not authenticated
  if (!isAuthenticated) {
    return <Login />;
  }

  // Render protected content if authenticated
  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
